const routes = {
    path: 'dores',
    name: 'Dores',
    component: () => import('./Dores.vue'),
    children: [
        {
            path: 'inserir',
            name: 'Dores_Inserir',
            component: () => import('./DoresForm.vue'),
            meta: {
                rules: ['SOL-001'],
            }
        },
        {
            path: ':id/atualizar',
            name: 'Dores_Atualizar',
            component: () => import('./DoresForm.vue'),
            meta: {
                rules: ['SOL-001'],
            }
        },
    ],
    meta: {
        rules: ['SOL-001'],
    }
};

export default routes;
